/**
 * Shared ticket persistence for ticketsApi and optional cross-module SLA touches.
 */

export const STORAGE_TICKETS = "sample-ui:support-tickets:v1";
export const STORAGE_HIGH_WATER = "sample-ui:support-tickets:high-water:v1";

/** @param {unknown} value */
export function normalizeTicketStatus(value) {
  const v = String(value ?? "")
    .toLowerCase()
    .replace(/\s+/g, "_");
  if (v === "pending") return "pending";
  if (v === "on_hold" || v === "on-hold") return "on_hold";
  if (v === "resolved" || v === "closed") return "resolved";
  if (v === "open") return "open";
  return "open";
}

export function readHighWaterMark() {
  if (typeof window === "undefined") return 1000;
  try {
    const raw = window.localStorage.getItem(STORAGE_HIGH_WATER);
    const n = raw ? parseInt(raw, 10) : 1000;
    return Number.isFinite(n) && n >= 1000 ? n : 1000;
  } catch {
    return 1000;
  }
}

export function writeHighWaterMark(n) {
  try {
    window.localStorage.setItem(STORAGE_HIGH_WATER, String(n));
  } catch {
    /* ignore */
  }
}

export function readTicketsFromStorage() {
  if (typeof window === "undefined") return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_TICKETS);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    if (!Array.isArray(parsed)) return [];
    return parsed.filter((t) => t && typeof t.id === "string" && typeof t.conversationId === "string");
  } catch {
    return [];
  }
}

export function writeTicketsToStorage(tickets) {
  try {
    window.localStorage.setItem(STORAGE_TICKETS, JSON.stringify(tickets));
  } catch {
    /* ignore */
  }
}

/**
 * When the customer posts in the linked conversation, advance requester activity for open tickets.
 * @param {string} conversationId
 * @param {string} [isoNow]
 */
export function bumpTicketRequesterActivityForConversation(conversationId, isoNow = new Date().toISOString()) {
  const prev = readTicketsFromStorage();
  let changed = false;
  const next = prev.map((t) => {
    if (t.conversationId !== conversationId) return t;
    const st = normalizeTicketStatus(t.status);
    if (st !== "open" && st !== "pending") return t;
    changed = true;
    return { ...t, lastRequesterActivityAt: isoNow };
  });
  if (changed) writeTicketsToStorage(next);
}
